// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup, Grid } from 'semantic-ui-react';
import GoogleMapReact from 'google-map-react';
import _ from 'lodash';
// actions
import { updateAutoUpdate, resetMapParams } from 'app/redux/actions/monitor';
// consts
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';
// css
import './MonitorMap.scss';

const Content = ({ name, flow, open, battery }) => {
    return (
        <Grid columns={1}>
            <Grid.Row>
                <Grid.Column id="patient-info">
                    <div className="row-name"><b>Paciente:</b> { name }</div>
                    <div className="row-flow">
                        <b>Fluxo:</b> { open ? flow + ' l/min' : '0 l/min'}
                    </div>
                    <div className="row-bat">
                        <b>Bateria:</b> { battery }
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

class MonitorMap extends Component {
    componentDidMount() {
        if (this.props.monitor.autoUpdate) {
            this.props.dispatch(updateAutoUpdate(false));
        }
    }

    componentWillUnmount() {
        this.props.dispatch(resetMapParams());
    }

    bateryState(batery, type) {
        switch (type) {
            case DEVICE_TYPE.CONCENTRATOR: {
                const batLow = batery < 3.3 ? true : false;
                const rawCapibility = batery - 3;
                let capibility = rawCapibility <= 0 ? 0 : `${parseInt((100 * rawCapibility) / 1.2, 10)}`;
                if (capibility > 100) capibility = 100;
                return { batteryLvl: `${capibility}%`, batLow };
            }
            default: {
                const batLow = batery < 3.7 ? true : false;
                const rawCapibility = batery - 3.3;
                let capibility = rawCapibility <= 0 ? 0 : `${parseInt((100 * rawCapibility) / 1.2, 10)}`;
                if (capibility > 100) capibility = 100;
                return { batteryLvl: `${capibility}%`, batLow };
            }
        }
    }

    renderMarker(row) {
        const deviceKey = row.device.key;
        const deviceType = row.device.type;
        const deviceBattery = row.device.battery;
        const { batteryLvl, batLow } = this.bateryState(deviceBattery, deviceType);
        const patientName = row.name;
        const flow = row.flow;
        const open = flow > 0 ? true : false;
        const latitude = row.device.latitude ? row.device.latitude : row.latitude;
        const longitude = row.device.longitude ? row.device.longitude : row.longitude;
        
        const Marker = () => {
            return <div className='marker-map'>
                <Popup 
                    id="popup-device-legend" 
                    trigger={<div className={deviceType === 5 ? `marker-concentrator ${open ? 'open' : ''} ${batLow ? 'low-bat' : ''}` : `marker-atas ${open ? 'open' : ''} ${batLow ? 'low-bat' : ''}`}></div>} 
                    header={deviceKey} 
                    content={<Content name={patientName} flow={flow} open={open} battery={batteryLvl} />} 
                />
            </div>
        };

        return latitude && longitude ? <Marker lat={latitude} lng={longitude}/> : null;
    }

    render() {
        const { data } = this.props;
        const { mapParams } = this.props.monitor;
        const { center, zoom } = mapParams;

        return (
            <div className='map'>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyAiy_QubqO50nV1w1I_HNN9oEGdOzDxSUo' }}
                    defaultCenter={center}
                    defaultZoom={zoom}
                >
                    {_.map(data, patient => this.renderMarker(patient))}
                </GoogleMapReact>
            </div>
        );
    }
};

MonitorMap.propTypes = {
    monitor: PropTypes.object,
    dispatch: PropTypes.func,
    data: PropTypes.array,
};

export default MonitorMap;
